import RespondentsConsumerAllSurveyPanel from './respondentsConsumerAllSurvey.container';

export default RespondentsConsumerAllSurveyPanel;